<template>
  <div>
    <template>
      <div class="text-center">
        <v-dialog v-model="dialogState" width="560" height="auto">
          <v-card style="background:#35362F">
            <div>
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/WwOtEnQCDnU"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogState: false
    }
  },
  watch: {
    dialog(val) {
      this.dialogState = val
    },
    dialogState(val) {
      this.$emit('update:dialog', val)
    }
  },
  methods: {
    turnOffDialog() {
      this.dialogState = false
      this.$emit('update:dialog', this.dialogState)
    }
  }
}
</script>

<style lang="css" scoped>
.anotation-box {
  order: 1px solid #fff;
  border-radius: 18px;
  font-size: 16px;
  font-family: sans-serif;
  line-height: 26px;
  color: #fff;
  text-align: center;
  user-select: none;
  background: rgba(0, 0, 0, 0.8);
}
</style>
